import React from 'react';
import type { PerimetreValue } from './PerimetreSelector';
import { usePerimetreReferentiel } from './usePerimetreReferentiel';
import { deptStateFromValue } from './perimetreCoverage';
import FranceMap from './FranceMap';
import PerimetreMapSkeleton from './PerimetreMapSkeleton';

interface PerimetreMapDisplayProps {
  value: PerimetreValue;
}

/**
 * Affichage en LECTURE SEULE du perimetre sur la carte de France.
 * Destine aux annuaires (acheteurs / prestataires) et a la modale de profil :
 * montre ce que l'organisme / l'entite a selectionne comme perimetre d'achat ou
 * d'intervention, sans interaction. Reutilise FranceMap + la couverture partagee.
 */
const PerimetreMapDisplay: React.FC<PerimetreMapDisplayProps> = ({ value }) => {
  const { referentiel, loading } = usePerimetreReferentiel();

  if (loading) {
    return <PerimetreMapSkeleton />;
  }

  const deptState = deptStateFromValue(value, referentiel);

  return <FranceMap deptState={deptState} onToggleDept={() => {}} disabled />;
};

export default PerimetreMapDisplay;
